import React from "react";

const AboutUs = () => {
  return (
    <div className=" py-10">
      <div className="max-w-screen-lg mx-auto px-6 text-center">
        {/* Heading */}
        <h2 className="text-2xl font-semibold text-[#07294D] mb-4 ml-2">
          About Us
        </h2>
        {/* Text Content */}
        <p className="text-lg text-gray-700 mb-8">
          Shree Krishna Academy is more than just a school—it’s a place where
          lives are transformed, and every child’s unique potential is nurtured.
          We are dedicated to providing a well-rounded education that empowers
          students to excel academically, thrive in sports, and grow into
          compassionate, thoughtful, and capable citizens of the future.
        </p>
        <p className="text-lg text-gray-700 mb-8">
          We firmly believe that every child is unique, full of energy, and
          capable of achieving greatness. Guided by our motto, “A School is a
          Place Where Good Thoughts are Born,” we prioritize creating an
          environment that shapes character, fosters leadership qualities, and
          inspires intellectual curiosity.
        </p>
        <p className="text-lg text-gray-700 mb-8">
          At Shree Krishna Academy, we recognize that the foundation of a
          thriving society lies in the education of its youth. We believe that
          true education goes beyond textbooks. It seeks to cultivate
          well-rounded individuals—good professionals, proficient linguists,
          innovative scientists, brilliant literary minds, and, most
          importantly, honest, virtuous, and kind-hearted human beings.
        </p>
        <p className="text-lg text-gray-700 mb-8">
          We uphold the principle that “Education is the Right of Every Child.”
          Regardless of economic background, caste, or religion, every child
          deserves an equal opportunity to learn, grow, and succeed.
        </p>
        <p className="text-lg text-gray-700 mb-8">
          Shree Krishna Academy accommodates both day scholars and hostellers.
          Day scholars from nearby areas benefit from efficient school transport
          services, while hostellers enjoy safe and nurturing accommodations in
          separate facilities for boys and girls.
        </p>
        <p className="text-lg text-gray-700 mb-8">
          At Shree Krishna Academy, we aim to inspire, educate, and empower
          every child to reach their full potential and contribute meaningfully
          to society.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
